/**
 * Regras do campo de markdown inline (AB#86817), separadas do componente para o Jest
 * do web — que só roda `.ts` — cobrir o que decide o comportamento.
 *
 * O campo abre SEMPRE na visão renderizada: é o que a maioria das pessoas lê, e o
 * código só interessa a quem vai editar.
 */

export type MarkdownView = 'rendered' | 'code';

export const INITIAL_VIEW: MarkdownView = 'rendered';

export function nextView(view: MarkdownView): MarkdownView {
  return view === 'rendered' ? 'code' : 'rendered';
}

/**
 * O botão mostra para onde ele leva, não onde se está: na renderizada, `<>` abre o
 * código; no código, o olho volta para a renderizada.
 */
export function toggleIcon(view: MarkdownView): 'code' | 'eye' {
  return view === 'rendered' ? 'code' : 'eye';
}

/** Quem não pode editar não vê o código: o campo fica preso na renderizada. */
export function visibleView(view: MarkdownView, readOnly: boolean): MarkdownView {
  return readOnly ? 'rendered' : view;
}

export interface LengthStatus {
  count: number;
  max: number;
  over: number;
  isOver: boolean;
}

export function lengthStatus(value: string, max: number): LengthStatus {
  const count = value.length;
  const over = Math.max(0, count - max);
  return { count, max, over, isOver: over > 0 };
}
